import {isClient} from 'hec/utils/common'
import {TpaGroupNames, TpaUrlParamIdentifiers} from './types'

export const getExpiryDateAndTimeForTpaCookies = (groupName: string) => {
    const currentTimestamp = Date.now()

    const days = groupName === TpaGroupNames.TPA ? 365 : 30
    const expiryDate = new Date(currentTimestamp + days * 24 * 60 * 60 * 1000)
    const expiryMs = expiryDate.getTime()

    return {
        expiryDate,
        expiryMs
    }
}

export const getTpaParamsFromUrl = () => {
    if (!isClient) return null

    const searchParams = new URLSearchParams(window.location.search)
    // Check for both uppercase and lowercase AFID parameters
    const afid = searchParams.get(TpaUrlParamIdentifiers.AFID) || searchParams.get('afid') || ''
    const groupName = searchParams.get(TpaUrlParamIdentifiers.GROUP_NAME)?.toLowerCase() || ''
    const cid = searchParams.get(TpaUrlParamIdentifiers.CID) || ''
    const parentId = searchParams.get(TpaUrlParamIdentifiers.PARENT_ID) || ''

    if (!afid && !groupName && !cid && !parentId) {
        return
    }

    return {
        afid,
        groupName,
        cid,
        parentId
    }
}
